import { useEffect, useState } from "react";
import * as React from "react";
import styled from "styled-components";

import { Box } from "@vinomofo/components";

import fingerPointingUp from "./finger-pointing-up.png";

const scrollToTop = (evt: React.MouseEvent<HTMLButtonElement>) => {
  evt.preventDefault();

  try {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  } catch (error) {
    window.scrollTo(0, 0);
  }
};

const Waggler = styled(Box)`
  appearance: none;
  outline: 0;
  border: 0;
  display: inline-block;
  overflow: visible;
  background: none;
  vertical-align: middle;
  cursor: pointer;

  &.animation-0 {
    img {
      animation-name: wave-animation;
      animation-duration: 2.5s;
      animation-iteration-count: 1;
      transform-origin: 70% 70%;
    }
  }

  &.animation-1 {
    img {
      animation: wobble-hor-bottom 1.2s ease-out 1 both;
    }
  }

  &.animation-2 {
    img {
      animation: shake-vertical 2s cubic-bezier(0.455, 0.03, 0.515, 0.955) 1
        both;
    }
  }

  @keyframes wave-animation {
    0% {
      transform: rotate(0deg);
    }
    10% {
      transform: rotate(-10deg);
    }
    20% {
      transform: rotate(12deg);
    }
    30% {
      transform: rotate(-10deg);
    }
    40% {
      transform: rotate(9deg);
    }
    50% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }

  @keyframes shake-vertical {
    0%,
    100% {
      transform: translateY(0);
    }
    10%,
    30%,
    50%,
    70% {
      transform: translateY(-2px);
    }
    20%,
    40%,
    60% {
      transform: translateY(2px);
    }
    80% {
      transform: translateY(1.6px);
    }
    90% {
      transform: translateY(-1.6px);
    }
  }

  @keyframes wobble-hor-bottom {
    0%,
    100% {
      transform: translateX(0%);
      transform-origin: 50% 50%;
    }
    15% {
      transform: translateX(-4px) rotate(-3deg);
    }
    30% {
      transform: translateX(4px) rotate(3deg);
    }
    45% {
      transform: translateX(-4px) rotate(-3.6deg);
    }
    60% {
      transform: translateX(2px) rotate(2.4deg);
    }
    75% {
      transform: translateX(-2px) rotate(-1.2deg);
    }
  }
`;

export const FooterWaggler = (): JSX.Element => {
  const [animation, setAnimation] = useState(0);

  useEffect(() => {
    const timeoutFn = setTimeout(() => {
      const nextAnimation = animation < 2 ? animation + 1 : 0;
      setAnimation(nextAnimation);
    }, 5000);
    return () => clearTimeout(timeoutFn);
  }, [animation]);

  return (
    <Waggler
      as="button"
      padding={["0 5px 0 5px", "0 5px 0 5px", "0 10px 0 5px"]}
      className={`animation-${animation}`}
      onClick={scrollToTop}
      my={["-14px", "-14px", "-25px"]}
      height={["28px", "28px", "50px"]}
    >
      <Box
        as="img"
        src={fingerPointingUp}
        alt="Finger pointing up"
        verticalAlign="middle"
        height="100%"
        width="auto"
      />
    </Waggler>
  );
};
